import { Layout, Row, Col, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { LEGAL_COPY } from '@rescue-foodies/shared-types';

const { Footer } = Layout;
const { Title, Text } = Typography;

export const AppFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Footer
      style={{
        background: '#001529',
        color: '#ffffff',
        marginTop: 'auto',
        padding: '48px 24px 24px',
      }}
    >
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <Row gutter={[32, 32]}>
          {/* Company Section */}
          <Col xs={24} sm={12} md={6}>
            <Title level={5} style={{ color: '#ffffff', marginBottom: 16 }}>
              Company
            </Title>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <Link to="/about" style={{ color: 'rgba(255,255,255,0.7)' }}>
                About Us
              </Link>
              <Link to="/" style={{ color: 'rgba(255,255,255,0.7)' }}>
                How It Works
              </Link>
              <a
                href="https://blog.rescuefoodies.ph"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'rgba(255,255,255,0.7)' }}
              >
                Blog
              </a>
            </div>
          </Col>

          {/* Support Section */}
          <Col xs={24} sm={12} md={6}>
            <Title level={5} style={{ color: '#ffffff', marginBottom: 16 }}>
              Support
            </Title>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <Link to="/contact" style={{ color: 'rgba(255,255,255,0.7)' }}>
                Contact Us
              </Link>
              <a
                href="mailto:rescuefoodies@gmail.com"
                style={{ color: 'rgba(255,255,255,0.7)' }}
              >
                rescuefoodies@gmail.com
              </a>
              <Text style={{ color: 'rgba(255,255,255,0.7)', fontSize: 14 }}>
                Help Center (coming soon)
              </Text>
            </div>
          </Col>

          {/* Legal Section */}
          <Col xs={24} sm={12} md={6}>
            <Title level={5} style={{ color: '#ffffff', marginBottom: 16 }}>
              Legal
            </Title>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <Link to="/terms" style={{ color: 'rgba(255,255,255,0.7)' }}>
                Terms and Conditions
              </Link>
              <Link to="/privacy" style={{ color: 'rgba(255,255,255,0.7)' }}>
                Privacy Policy
              </Link>
              <Text style={{ color: 'rgba(255,255,255,0.7)', fontSize: 14 }}>
                Cancellations & Refunds (coming soon)
              </Text>
            </div>
          </Col>

          {/* Social Section */}
          <Col xs={24} sm={12} md={6}>
            <Title level={5} style={{ color: '#ffffff', marginBottom: 16 }}>
              Connect
            </Title>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <a
                href="https://facebook.com/rescuefoodies"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'rgba(255,255,255,0.7)' }}
              >
                Facebook
              </a>
              <a
                href="https://instagram.com/rescuefoodies"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'rgba(255,255,255,0.7)' }}
              >
                Instagram
              </a>
              <a
                href="https://twitter.com/rescuefoodies"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'rgba(255,255,255,0.7)' }}
              >
                Twitter
              </a>
            </div>
          </Col>
        </Row>

        {/* Marketplace Notice */}
        <div
          style={{
            marginTop: 32,
            paddingTop: 24,
            borderTop: '1px solid rgba(255,255,255,0.1)',
          }}
        >
          <Text style={{ color: 'rgba(255,255,255,0.6)', fontSize: 12, display: 'block' }}>
            {LEGAL_COPY.footer.marketplaceNotice}
          </Text>
        </div>

        {/* Copyright */}
        <div style={{ marginTop: 16, textAlign: 'center' }}>
          <Text style={{ color: 'rgba(255,255,255,0.6)', fontSize: 12 }}>
            {LEGAL_COPY.footer.copyright(currentYear)}
          </Text>
        </div>
      </div>
    </Footer>
  );
};
